<template>
    <div>
        <ContentLink :href="question.content_url">
            <Title>{{question.title}}</Title>
        </ContentLink>
        <UserInfo :memberName="question.author.name" :memberUrl="question.author.profile_url" :avatarUrl="question.author.avatar_url"></UserInfo>
        <ContentTags :tags="question.tags"></ContentTags>
    </div>
</template>

<script>
    import ContentTags from '../shared/ContentTags'
    import ContentLink from '../shared/card/ContentLink'
    import UserInfo from '../shared/card/UserInfo'
    import Title from '../shared/card/Title'


    export default {
        name: 'Tutorial',
        props: {
            question: Object
        },
        components: {
            UserInfo,
            ContentLink,
            ContentTags,
            Title
        }
    }
</script>
